import 'bootstrap/dist/css/bootstrap.min.css'
import moment from 'moment'
import 'moment/locale/pt-br'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import App from './componentes/App'
import ErroBackendPage from './componentes/ErroBackendPage'
import Carregando from './componentes/Carregando'
import './index.scss'
import { persistor, store } from './modulos'
import ReactGA from 'react-ga'
import { createBrowserHistory } from 'history'

// Configura o Locale para o moment.js
moment.locale('pt-br')

// Date.prototype.toJSON = function(){ return moment(this).toISOString(); }

const history = createBrowserHistory()
const { REACT_APP_TRACKINGID } = process.env

// Inicializando o Google Analytics
if (process.env.REACT_APP_TRACKINGID != null) {
    ReactGA.initialize(REACT_APP_TRACKINGID, {
        cookieDomain: 'auto',
    })

    history.listen(location => {
        ReactGA.set({ page: window.location.href }) // Update the user's current page
        ReactGA.pageview(window.location.href) // Record a pageview for the given page
    })
}

//  Adiciona preloads
const head = document.querySelector('head')
const preloads = [
    { href: 'icones/settings.png', as: 'image', type: 'image/png' },
    { href: 'icones/settings.svg', as: 'image', type: 'image/svg+xml' },
    { href: 'icones/settings.svg', as: 'fetch', type: 'image/svg+xml' },
]

preloads.map(preload => {
    const link = document.createElement('link')
    link.setAttribute('rel', 'preload')

    Object.keys(preload).map(attribute => link.setAttribute(attribute, preload[attribute]))

    head.appendChild(link)
})

console.debug('Carregando config...')
fetch('./config/config.json')
    .then(function (res) {
        console.debug('Config carregada! Convertendo para JSON...')
        return res.json()
    })
    .then(function (data) {
        // Validando config
        if (!data.url) throw new Error('Problemas de comunicação com o servidor de dados!')
        console.debug('Config em JSON, gravando storage...')
        // store Data in State Data Variable
        data.usuario = 'acessodireto'
        data.senha = 'acessodireto'
        sessionStorage.setItem('config', JSON.stringify(data))
        // self.setState({ config: data })
        console.debug('React Render!')
        ReactDOM.render(
            <Provider store={store} history={history}>
                <PersistGate loading={<Carregando />} persistor={persistor}>
                    <App />
                </PersistGate>
            </Provider>,
            document.getElementById('root')
        )
    })
    .catch(function (err) {
        console.error(err, ' error')
        ReactDOM.render(<ErroBackendPage />, document.getElementById('root'))
    })

const observer = new MutationObserver((mutationsList, observer) => {
    const iconeOcultaFiltro = document.querySelector('.iconeOcultaFiltro')
    const searchBarOpen = document.querySelector('.pesquisaInputMobile.inputAberto')
    const searchBarClosed = document.querySelector('.pesquisaInputMobile.inputFechado')

    if (!iconeOcultaFiltro) {
        return
    }

    if (document.querySelector('.programa-area-lateral')) {
        document.querySelectorAll('.iconeOcultaFiltro')[0].style.display = 'inline-block'
        document.querySelectorAll('.iconeOcultaFiltro')[1].style.display = 'inline-block'

        if (searchBarOpen) {
            searchBarOpen.style.width = 'calc(100% - 95px)'
        } else if (searchBarClosed) {
            searchBarClosed.style.width = '0'
        }
    } else {
        document.querySelectorAll('.iconeOcultaFiltro')[0].style.display = 'none'
        document.querySelectorAll('.iconeOcultaFiltro')[1].style.display = 'none'

        if (searchBarOpen) {
            searchBarOpen.style.width = 'calc(100% - 65px)'
        } else if (searchBarClosed) {
            searchBarClosed.style.width = '0'
        }
    }
})

// Select the node that will be observed for mutations
const targetNode = document.getElementById('root')

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true }

observer.observe(targetNode, config)
